var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { TextField } from "@material-ui/core";
import NumberFormat from "react-number-format";
function NumberFormatCustom(props) {
    var inputRef = props.inputRef, onChange = props.onChange, other = __rest(props, ["inputRef", "onChange"]);
    return (React.createElement(NumberFormat, __assign({}, other, { getInputRef: inputRef, onValueChange: function (values) {
            onChange({
                target: {
                    name: props.name,
                    value: values.value
                }
            });
        }, thousandSeparator: true, isNumericString: true, prefix: "\u00A3" })));
}
/**
 * Currency Input field
 * @see https://material-ui.com/components/text-fields/#integration-with-3rd-party-input-libraries
 * @param props
 * @constructor
 */
export var CurrencyField = function (props) {
    return (React.createElement(TextField, __assign({}, props, { variant: "outlined", InputProps: {
            inputComponent: NumberFormatCustom
        } })));
};
//# sourceMappingURL=CurrencyField.js.map